import { useTranslation } from 'react-i18next'

const LANGS = {
  es: { flag: '🇪🇸', label: 'ES' },
  en: { flag: '🇺🇸', label: 'EN' },
}

function LanguageSwitcher({ className = '' }) {
  const { i18n } = useTranslation()
  const currentLang = i18n.language?.startsWith('en') ? 'en' : 'es'
  const nextLang = currentLang === 'es' ? 'en' : 'es'

  const toggle = () => {
    i18n.changeLanguage(nextLang)
  }

  return (
    <button
      onClick={toggle}
      title={currentLang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
      className={`flex items-center gap-1.5 text-sm font-semibold px-3 py-1.5 rounded-lg border transition-colors duration-200 ${className}`}
    >
      <span className="text-base leading-none">{LANGS[currentLang].flag}</span>
      <span>{LANGS[nextLang].label}</span>
    </button>
  )
}

export default LanguageSwitcher
